export default function getResource(label, vars = []) {
    const resources = {
        email: 'Email',
        edit: 'Edit',
        confirmEmailLabel: 'Confirm email',
        cancel: 'Cancel',
        update: 'Update',
        emptyEmailMessage: 'Please fill out this field.',
        invalidConfirmationMessage: 'The email addresses you entered do not match. Please fix to continue.',
        invalidEmailMessage: 'Please enter an e-mail address in the format username@domain.com.',
        invalidEmailError: 'Invalid email address type. Please use a valid email address',
        warningTextTitle: 'Are you sure?',
        warningPasskeyText1: 'Changing your email address will also remove all passkeys currently linked to your Sephora account.',
        warningPasskeyText2: 'After the change, you can easily set up new passkeys to keep enjoying fast, seamless sign‑in.',
        warningPasskeyText3: 'Would you like to continue?',
        continue: 'Continue'
    };
    return resources[label];
}
